// extracted by mini-css-extract-plugin
module.exports = {"pageDefaultWrapper":"pageDefault_pageDefaultWrapper__1Hu3y"};